/// <reference path='../../../../typings/index.d.ts' />
/// <reference path='controls.module.ts' />

module Meevo.Components.Controls {
    'use strict';

    export class MeevoTextAreaWithTags implements angular.IDirective {
        restrict = 'E';
        scope = {
            currentValue: '=ngModel',
            disabled: '=ngDisabled',
            charLimit: '=',
            tags: '=',
            name: '@',
            warningMessage: '=?'
        };

        templateUrl = 'app/components/controls/textAreaWithTagsTemplate.html';

        constructor() {

        }

        link = (scope: any) => {
            scope.addTag = addTag;

            /**
             * Add tag to notification provided
             * @param {string} tag - tag
             * */
            function addTag (tag: string): void {
                let currentValue = scope.currentValue;

                if (typeof currentValue === 'undefined') { // if angular reset model's value because of max-length attr
                    return;
                }

                if (`${currentValue} {${tag}}`.length > scope.charLimit && !scope.warningMessage) {
                    return;
                }

                scope.currentValue += ` {${tag}}`;
            }
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoTextAreaWithTags();
            };

            directive.$inject = [];

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoTextAreaWithTags', MeevoTextAreaWithTags.factory());
}